import { useEffect } from 'react';
import { executeScriptSecurely } from '@/utils/secureWeb3Provider';

export const OrganizationSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "url": "https://mdbapp.io",
    "logo": "https://mdbapp.io/images/mdb-social-high-res.png",
    "name": "MDBApp.io",
    "description": "Create your own cryptocurrency token in minutes with our easy-to-use token generator. Support for ETH, BSC, Polygon & Avalanche.",
    "sameAs": []
  };

  useEffect(() => {
    // Add schema.org JSON-LD with proper nonce
    executeScriptSecurely(`
      var schemaScript = document.createElement('script');
      schemaScript.type = 'application/ld+json';
      schemaScript.textContent = ${JSON.stringify(JSON.stringify(schema))};
      document.head.appendChild(schemaScript);
    `);
    
    // Add Bing-specific meta tags
    const metaTags = [
      { name: 'msapplication-TileImage', content: 'https://mdbapp.io/images/mdb-social-high-res.png' },
      { name: 'msapplication-TileColor', content: '#000000' },
      { name: 'msapplication-config', content: 'none' }
    ];
    
    metaTags.forEach(tag => {
      if (!document.querySelector(`meta[name="${tag.name}"]`)) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        meta.setAttribute('content', tag.content);
        document.head.appendChild(meta);
      }
    });
  }, []);

  return null;
};
